module.exports = __webpack_public_path__ + "img/icon5.a0eb4b5c.png";